import { Fragment } from 'react';

import { rage } from '~/rage';

import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { BgShadow } from '../BgShadow';
import { BgShadowContainer } from '../BgShadowContainer';

const Background = () => (
	<Fragment>
		{rage.config.isStub() && <BgPlaceholder $type={PlaceholderType.Default} />}
		<BgShadowContainer>
			<BgShadow />
			<BgShadow />
			<BgShadow />
			<BgShadow />
		</BgShadowContainer>
	</Fragment>
);

export { Background };
